var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 475,
    viewBox: "0 0 1920 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1689.3 278.035C1694.29 278.035 1694.29 270.283 1689.3 270.283C1684.32 270.283 1684.32 278.035 1689.3 278.035Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1738.88 336.876C1741.39 336.876 1741.39 333 1738.88 333C1736.37 333 1736.37 336.876 1738.88 336.876Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1640.57 313.509C1643.08 313.509 1643.08 309.633 1640.57 309.633C1638.06 309.633 1638.06 313.509 1640.57 313.509Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M608.74 369.751C613.727 369.751 613.727 362 608.74 362C603.753 362 603.753 369.751 608.74 369.751Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.68 129.751C271.666 129.751 271.666 122 266.68 122C261.693 122 261.693 129.751 266.68 129.751Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.88 239.405C195.386 239.405 195.386 235.529 192.88 235.529C190.373 235.529 190.373 239.405 192.88 239.405Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.356 344.1C267.863 344.1 267.863 340.225 265.356 340.225C262.85 340.225 262.85 344.1 265.356 344.1Z",
    fill: "#A3EA2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSmall);
export default __webpack_public_path__ + "static/media/dots-small.34880d02138623b017f1f744d8a6ecb9.svg";
export { ForwardRef as ReactComponent };